<div class="w-100">
  <h1 class="head1">Add/Delete/Modify Devices</h1>
</div>
<div class="row">
  <div class="col-md-6 mb-3">
    <div class="card shadow-sm p-3" id="div1">
      <h5 class="font-15p mb-3">{{ addDeviceHeaderText }}</h5>

      <div class="mb-2 row">
        <label class="col-form-label col-md-3 py-0"
          >Search by Consumer ID/Name</label
        >
        <div class="col-md-9">
          <div class="d-flex">
            <input
              type="text"
              class="form-control me-2"
              [(ngModel)]="searchKey"
              required
            />
            <button
              class="btn btn-primary-sa text-nowrap"
              (click)="getDeviceByNameOrId(searchKey)"
            >
              Get Device
            </button>
          </div>
          <div *ngIf="searchTermInvalid" class="text-danger">
            Please enter Name or ID
          </div>
        </div>
      </div>

      <form [formGroup]="addDeviceForm">
        <div class="mb-2 row">
          <label class="col-form-label col-md-3"
            >Consumer ID<span class="text-danger">*</span></label
          >
          <div class="col-md-9">
            <input
              type="text"
              class="form-control"
              formControlName="consumerId"
            />
            <p
              *ngIf="
                getControl('consumerId')?.invalid &&
                getControl('consumerId')?.touched
              "
              class="text-danger m-0"
            >
              Consumer ID is required.
            </p>
          </div>
        </div>
        <div class="mb-2 row">
          <label class="col-form-label col-md-3"
            >Group<span class="text-danger">*</span></label
          >
          <div class="col-md-9">
            <div class="d-flex">
              <select
                name=""
                id=""
                class="form-select me-2"
                formControlName="group"
                [(ngModel)]="selectedGroup"
              >
                <option value="" disabled selected>Select a group</option>
                <option *ngFor="let zone of zone" [value]="zone.id">
                  {{ zone.name }}
                </option>
              </select>
              <button
                class="btn btn-primary-sa text-nowrap"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#createGroupModel"
              >
                Create New
              </button>
            </div>
            <p
              *ngIf="
                getControl('group')?.invalid && getControl('group')?.touched
              "
              class="text-danger m-0"
            >
              Group is required.
            </p>
          </div>
        </div>
        <div class="mb-2 row">
          <label class="col-form-label col-md-3"
            >Device Type<span class="text-danger">*</span></label
          >
          <div class="col-md-9">
            <select
              name=""
              id=""
              class="form-select"
              formControlName="deviceType"
            >
              <option
                *ngFor="let deviceType of deviceType"
                [value]="deviceType.id"
              >
                {{ deviceType.type }}
              </option>
            </select>
            <p
              *ngIf="
                getControl('deviceType')?.invalid &&
                getControl('deviceType')?.touched
              "
              class="text-danger m-0"
            >
              Device Type is required.
            </p>
          </div>
        </div>

        <div class="mb-2 row">
          <label class="col-form-label col-md-3"
            >Dev EUI<span class="text-danger">*</span></label
          >
          <div class="col-md-9">
            <input type="text" class="form-control" formControlName="devUi" />
            <p
              *ngIf="
                getControl('devUi')?.invalid && getControl('devUi')?.touched
              "
              class="text-danger m-0"
            >
              Dev EUI is required.
            </p>
          </div>
        </div>
        <div class="mb-2 row">
          <label class="col-form-label col-md-3"
            >Usage Type<span class="text-danger">*</span></label
          >
          <div class="col-md-9">
            <select
              name=""
              id=""
              class="form-select"
              formControlName="usageType"
            >
              <option
                *ngFor="let usageType of usageType"
                [value]="usageType.id"
              >
                {{ usageType.type }}
              </option>
            </select>
            <p
              *ngIf="
                getControl('usageType')?.invalid &&
                getControl('usageType')?.touched
              "
              class="text-danger m-0"
            >
              Usage Type is required.
            </p>
          </div>
        </div>
        <div class="mb-2 row">
          <label class="col-form-label col-md-3"
            >Consumer Name<span class="text-danger">*</span></label
          >
          <div class="col-md-9">
            <input
              type="text"
              class="form-control"
              formControlName="ConsumerName"
            />
            <p
              *ngIf="
                getControl('ConsumerName')?.invalid &&
                getControl('ConsumerName')?.touched
              "
              class="text-danger m-0"
            >
              Consumer Name is required.
            </p>
          </div>
        </div>
        <div class="mb-2 row">
          <label class="col-form-label col-md-3"
            >Consumer Phone Number<span class="text-danger">*</span></label
          >
          <div class="col-md-3">
            <select
              class="form-control"
              formControlName="countryCode"
              [(ngModel)]="defaultCountryCode"
            >
              <option
                *ngFor="let country of countryCodes"
                [value]="country.dial_code"
              >
                {{ country.name }} ({{ country.dial_code }})
              </option>
            </select>
            <p
              *ngIf="
                getControl('countryCode')?.invalid &&
                getControl('countryCode')?.touched
              "
              class="text-danger m-0"
            >
              Please select Country Code.
            </p>
          </div>

          <div class="col-md-6">
            <input
              type="text"
              class="form-control"
              formControlName="ConsumerPhone"
              placeholder="Enter phone number"
            />
            <p
              *ngIf="
                getControl('ConsumerPhone')?.invalid &&
                getControl('ConsumerPhone')?.touched
              "
              class="text-danger m-0"
            >
              Consumer phone number is required and should be 10 digits.
            </p>
          </div>
        </div>
        <div class="mb-2 row">
          <label class="col-form-label col-md-3"
            >Consumer Address<span class="text-danger">*</span></label
          >
          <div class="col-md-9">
            <textarea
              name=""
              id=""
              class="form-control"
              formControlName="consumerAddress"
            ></textarea>
            <p
              *ngIf="
                getControl('consumerAddress')?.invalid &&
                getControl('consumerAddress')?.touched
              "
              class="text-danger m-0"
            >
              Consumer Address is required.
            </p>
          </div>
        </div>
        <div class="mb-2 row">
          <label class="col-form-label col-md-3"
            >Commission Date<span class="text-danger">*</span></label
          >
          <div class="col-md-9">
            <input
              type="text"
              class="form-control"
              placeholder="Select a date"
              bsDatepicker
              [bsConfig]="datePickerConfig"
              formControlName="commissiondate"
              (keydown)="preventInput($event)"
            />
            <p
              *ngIf="
                getControl('commissiondate')?.invalid &&
                getControl('commissiondate')?.touched
              "
              class="text-danger m-0"
            >
              Date is required.
            </p>
          </div>
        </div>
        <div class="mb-2 row">
          <label class="col-form-label col-md-3"
            >Latitude<span class="text-danger">*</span></label
          >
          <div class="col-md-9">
            <input
              type="text"
              class="form-control"
              formControlName="latitude"
            />
            <p
              *ngIf="
                getControl('latitude')?.hasError('required') &&
                getControl('latitude')?.touched
              "
              class="text-danger m-0"
            >
              Latitude is required.
            </p>
            <p
              *ngIf="
                (getControl('latitude')?.hasError('pattern') ||
                  getControl('latitude')?.hasError('min') ||
                  getControl('latitude')?.hasError('max')) &&
                getControl('latitude')?.touched
              "
              class="text-danger m-0"
            >
              Latitude must be valid.
            </p>
          </div>
        </div>
        <div class="mb-2 row">
          <label class="col-form-label col-md-3"
            >Longitude<span class="text-danger">*</span></label
          >
          <div class="col-md-9">
            <input
              type="text"
              class="form-control"
              formControlName="longitude"
            />
            <p
              *ngIf="
                getControl('longitude')?.hasError('required') &&
                getControl('longitude')?.touched
              "
              class="text-danger m-0"
            >
              Longitude is required.
            </p>
            <p
              *ngIf="
                (getControl('longitude')?.hasError('pattern') ||
                  getControl('longitude')?.hasError('min') ||
                  getControl('longitude')?.hasError('max')) &&
                getControl('longitude')?.touched
              "
              class="text-danger m-0"
            >
              Longitude must be valid.
            </p>
          </div>
        </div>

        <div class="mb-2 row">
          <label class="col-form-label col-md-3">&nbsp;</label>
          <div class="col-md-9 text-end">
            <button
              type="button"
              class="btn btn-secondary-sa ms-2 mb-2"
              (click)="oncancel()"
            >
              Cancel
            </button>
            <button
              class="btn btn-primary-sa ms-2 mb-2"
              (click)="onSubmitAddDevice()"
            >
              {{ addDeviceBlockSubmitText }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-md-6 mb-3">
    <div class="card shadow-sm p-3">
      <h5 class="font-15p mb-3">Delete Device</h5>
      <p class="fw-600">Delete Device by Consumer ID</p>
      <div class="mb-2 row">
        <label class="col-form-label col-md-3"
          >Consumer ID/Name<span class="text-danger">*</span></label
        >
        <div class="col-md-9">
          <div class="d-flex">
            <input
              type="text"
              class="form-control me-2"
              [(ngModel)]="consumerID"
              #isConsumerId="ngModel"
              required
            />
            <button
              class="btn btn-primary-sa text-nowrap"
              (click)="getDevice(isConsumerId)"
            >
              Get Device
            </button>
          </div>
          <ul
            *ngIf="matchingConsumerIDs.length > 0"
            class="dropdown-menu show position-absolute"
            style="z-index: 9999"
          >
            <li
              *ngFor="let consumer_id of matchingConsumerIDs"
              class="dropdown-item"
              (click)="selectConsumerID(consumer_id)"
            >
              {{ consumer_id }}
            </li>
          </ul>
          <div *ngIf="isConsumerId.invalid && isConsumerId.touched">
            <p class="text-danger">Please enter Consumer ID/Name</p>
          </div>
        </div>
      </div>
      <div class="mb-2 row">
        <label class="col-form-label col-md-3">Device EUI</label>
        <div class="col-md-9">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="deviceIDs"
            readonly
          />
        </div>
      </div>
      <div class="mb-4 row">
        <label class="col-form-label col-md-3">&nbsp;</label>
        <div class="col-md-9 text-end">
          <button
            [ngClass]="
              deviceIDs
                ? 'btn btn-primary-sa text-nowrap'
                : 'btn btn-secondary-sa'
            "
            [disabled]="!deviceIDs"
            (click)="deleteDeviceConfirmation(isConsumerId)"
          >
            Delete
          </button>
        </div>
      </div>

      <div class="mb-3">
        <div class="float-start">
          <p class="fw-600 m-0">Delete Devices by uploading excel/csv file</p>
        </div>
        <div class="float-end">
          <a
            class="font-10p text-secondary m-0"
            id="downloadSapmleFile"
            (click)="downloadSampleFile()"
            >Download Sample excel</a
          >
        </div>
      </div>
      <div class="mb-5 row">
        <label class="col-form-label col-md-3"
          >Select File<span class="text-danger">*</span></label
        >
        <div class="col-md-9">
          <div class="d-flex">
            <input
              type="file"
              class="form-control me-2"
              #fileInput
              (change)="onFileChange($event)"
              accept=".xlsx, .xls, .csv"
            />
            <button
              class="btn btn-primary-sa text-nowrap"
              (click)="deleteDeviceByFileUpload()"
            >
              Delete
            </button>
          </div>
          <div *ngIf="fileErrorMessage" class="text-danger">
            {{ fileErrorMessage }}
          </div>
        </div>
      </div>
      <div class="mb-3">
        <p class="fw-600 m-0">Delete Devices by Group</p>
      </div>
      <div class="mb-2 row">
        <label class="col-form-label col-md-3"
          >Select Group<span class="text-danger">*</span></label
        >
        <div class="col-md-9">
          <div class="d-flex">
            <select
              name="deleteByGroup"
              class="form-select me-2"
              [(ngModel)]="selectedZone"
              #zoneSelect="ngModel"
              required
              [ngClass]="{
                isInvalid: zoneSelect.invalid && zoneSelect.touched
              }"
            >
              <option value="" disabled selected>Select a group</option>
              <option *ngFor="let zone of zone" [value]="zone.id">
                {{ zone.name }}
              </option>
            </select>

            <button
              class="btn btn-primary-sa text-nowrap"
              (click)="deleteDeviceByZone(zoneSelect)"
            >
              Delete
            </button>
          </div>
          <p
            class="text-danger m-0"
            *ngIf="zoneSelect.invalid && zoneSelect.touched"
          >
            please select a Group.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="createGroupModel"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Create Group</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <form [formGroup]="createGroup">
        <div class="modal-body">
          <div class="mb-2">
            <label class="col-form-label">Group Name</label>
            <input
              type="text"
              class="form-control"
              formControlName="groupName"
              required
            />
            <p
              *ngIf="
                createGroup.get('groupName')?.invalid &&
                createGroup.get('groupName')?.touched
              "
              class="text-danger m-0"
            >
              Group Name is required.
            </p>
          </div>
        </div>
      </form>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary-sa ms-2"
          data-bs-dismiss="modal"
          (click)="closeModal()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary-sa ms-2"
          (click)="createNewGroup()"
        >
          Create
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="securityTokenConfirmation"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <form #frm="ngForm" (submit)="frm.form.valid && onSubmit(frm)">
        <div class="modal-header">
          <h5 class="modal-title">Security Token</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
          ></button>
        </div>
        <div class="modal-body">
          <label class="form-label">Enter security token</label>
          <input
            type="text"
            name="token"
            class="form-control"
            ngModel
            #tokenInput="ngModel"
            required
          />
          <div *ngIf="frm.submitted && tokenInput.invalid" class="text-danger">
            Security token is required.
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Close
          </button>
          <button type="submit" class="btn btn-primary-sa">Submit</button>
        </div>
      </form>
    </div>
  </div>
</div>
